import { render, staticRenderFns } from "./collect.vue?vue&type=template&id=3e70b074&scoped=true"
import script from "./collect.vue?vue&type=script&lang=ts"
export * from "./collect.vue?vue&type=script&lang=ts"
import style0 from "./collect.vue?vue&type=style&index=0&id=3e70b074&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e70b074",
  null
  
)

export default component.exports